import { LEVEL_EXP_TABLE } from '../../domain/goldExpSystem.js';

export class HudUI {
  constructor({
    playerNamePlate, playerHpBar, playerTurretAlert, playerPlate,
    levelText, goldText, adStatText, asStatText, msStatText, expBarInner,
    qSkillSlot, qCdOverlay, wSkillSlot, wCdOverlay, eSkillSlot, eCdOverlay, rSkillSlot, rCdOverlay,
    dSkillSlot, dCdOverlay, dSpellAbbr, fSkillSlot, fCdOverlay, fSpellAbbr,
    windupBarInner, selectionReticleMesh, minionsUiContainer, turretsUiContainer
  }) {
    this.playerNamePlate = playerNamePlate;
    this.playerHpBar = playerHpBar;
    this.playerTurretAlert = playerTurretAlert;
    this.playerPlate = playerPlate;
    this.levelText = levelText;
    this.goldText = goldText;
    this.adStatText = adStatText;
    this.asStatText = asStatText;
    this.msStatText = msStatText;
    this.expBarInner = expBarInner;
    this.qSkillSlot = qSkillSlot;
    this.qCdOverlay = qCdOverlay;
    this.wSkillSlot = wSkillSlot;
    this.wCdOverlay = wCdOverlay;
    this.eSkillSlot = eSkillSlot;
    this.eCdOverlay = eCdOverlay;
    this.rSkillSlot = rSkillSlot;
    this.rCdOverlay = rCdOverlay;
    this.dSkillSlot = dSkillSlot;
    this.dCdOverlay = dCdOverlay;
    this.dSpellAbbr = dSpellAbbr;
    this.fSkillSlot = fSkillSlot;
    this.fCdOverlay = fCdOverlay;
    this.fSpellAbbr = fSpellAbbr;
    this.windupBarInner = windupBarInner;
    this.selectionReticleMesh = selectionReticleMesh;
    this.minionsUiContainer = minionsUiContainer;
    this.turretsUiContainer = turretsUiContainer;
  }

  applyHpTicks(outerBox, maxHp, step = 50) {
    const numTicks = Math.floor(maxHp / step);
    for (let i = 1; i <= numTicks; i++) {
      const pct = ((i * step) / maxHp) * 100;
      if (pct < 98) {
        const tick = document.createElement('div');
        tick.className = 'hp-tick';
        tick.style.left = `${pct}%`;
        outerBox.appendChild(tick);
      }
    }
  }

  updateChampionHUD(championEntity, redTurretEntity) {
    this.playerNamePlate.textContent = `${championEntity.name} (Nv. ${championEntity.level})`;
    if (this.levelText) this.levelText.textContent = `${championEntity.level}`;
    if (this.goldText) this.goldText.textContent = `🪙 ${Math.floor(championEntity.gold)}g`;

    if (this.adStatText) this.adStatText.textContent = `⚔️ ${Math.round(championEntity.ad)}`;
    if (this.asStatText) this.asStatText.textContent = `⚡ ${championEntity.as.toFixed(2)}`;
    if (this.msStatText) this.msStatText.textContent = `🥾 ${Math.round(championEntity.ms)}`;

    const currentTargetExp = LEVEL_EXP_TABLE[championEntity.level] || 3000;
    const prevTargetExp = LEVEL_EXP_TABLE[championEntity.level - 1] || 0;
    const expProgress = Math.min(100, Math.max(0, ((championEntity.exp - prevTargetExp) / (currentTargetExp - prevTargetExp)) * 100));
    this.expBarInner.style.width = `${expProgress}%`;

    const targetedByTurret = redTurretEntity.aggroTarget === championEntity && !redTurretEntity.isDead;
    this.playerTurretAlert.style.display = targetedByTurret ? 'block' : 'none';

    // Skill cooldowns
    this.updateCooldownSlot(this.rSkillSlot, this.rCdOverlay, championEntity.rCooldown, true);
    this.updateCooldownSlot(this.eSkillSlot, this.eCdOverlay, championEntity.eCooldown, false);
    this.updateCooldownSlot(this.wSkillSlot, this.wCdOverlay, championEntity.wCooldown, false);

    if (championEntity.qActive) {
      this.qSkillSlot.className = 'skill-slot active';
      this.qCdOverlay.style.display = 'none';
    } else {
      this.updateCooldownSlot(this.qSkillSlot, this.qCdOverlay, championEntity.qCooldown, false);
    }

    const windupTimeMax = (1.0 / championEntity.as) * championEntity.windupPercent;
    const progress = Math.min(100, (championEntity.windupTimer / windupTimeMax) * 100);
    this.windupBarInner.style.width = `${progress}%`;
  }

  /** Sync D/F summoner slots from caster snapshot (P3-32). */
  updateSummonerHUD(snapshot) {
    if (!snapshot) return;
    this.paintSummonerSlot(
      this.dSkillSlot, this.dCdOverlay, this.dSpellAbbr, snapshot.D, 'D'
    );
    this.paintSummonerSlot(
      this.fSkillSlot, this.fCdOverlay, this.fSpellAbbr, snapshot.F, 'F'
    );
  }

  paintSummonerSlot(slotEl, overlayEl, abbrEl, slot, key) {
    if (!slotEl || !slot) return;
    if (abbrEl) abbrEl.textContent = slot.abbr || '?';
    slotEl.title = `${key}: ${slot.name}`;
    const onCd = slot.cooldown > 0;
    slotEl.className = onCd ? 'skill-slot summoner cooldown' : 'skill-slot summoner';
    if (!overlayEl) return;
    if (onCd) {
      overlayEl.style.display = 'flex';
      overlayEl.textContent = Math.ceil(slot.cooldown);
      return;
    }
    overlayEl.style.display = 'none';
  }

  updateCooldownSlot(slotEl, overlayEl, cooldownVal, isUlt = false) {
    const baseClass = isUlt ? 'skill-slot ult' : 'skill-slot';
    if (cooldownVal > 0) {
      slotEl.className = `${baseClass} cooldown`;
      overlayEl.style.display = 'flex';
      overlayEl.textContent = Math.ceil(cooldownVal);
    } else {
      slotEl.className = baseClass;
      overlayEl.style.display = 'none';
    }
  }
}
